<template>
  <b-button :size="size" :variant="variant" @click="startFlow(id)"><i class="fas fa-list-check"></i> Walk Me Through This</b-button>
</template>

<script>
export default {
  props: {
    id: null,
    variant: null,
    size: null,
  },
  methods: {
    startFlow() {
      userpilot.trigger(this.id);
    }
  }
}
</script>